<template>
<div>
    <Breadcrumbs main="HR" submain="Payroll" title="Disbursement Details" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div v-if="details">

                    <b-row class="mb-4">
                        <b-col md="3" class="d-flex">
                            <div class="card custom-card p-3 w-100">
                                <small class="text-muted">{{ details.title }}</small>
                                <h6 class="mt-2">{{ formatPayrollMonth(
    details.payroll_sheet.month,
    details.payroll_sheet.year
) }}</h6>
                            </div>
                        </b-col>

                        <b-col md="3" class="d-flex">
                            <div class="card custom-card p-3 w-100">
                                <small class="text-muted">Status</small>

                                <span class="badge mt-2" :class="{
                    'bg-success': details.status === 'DISBURSED',
                    'bg-warning': details.status === 'PENDING',
                    'bg-secondary': !['DISBURSED', 'PENDING'].includes(details.status)
                }" style="width: fit-content;">
                                    {{ details.status }}
                                </span>
                            </div>
                        </b-col>

                        <b-col md="3" class="d-flex">
                            <div class="card custom-card p-3 w-100">
                                <small class="text-muted">Total Amount</small>
                                <h6 class="mt-2">{{ formatCurrency(details.total_pay_amount) }}</h6>
                            </div>
                        </b-col>

                        <b-col md="3" class="d-flex">
                            <div class="card custom-card p-3 w-100">
                                <small class="text-muted">Approved By</small>
                                <h6 class="mt-2">{{ details.approved_by?.full_name || '-' }}</h6>
                            </div>
                        </b-col>
                    </b-row>

                    <div class="card custom-card">

                        <h6 class="card-header">
                            Disbursement Entries
                        </h6>

                        <div class="card-body">

                            <b-row>
                                <b-col xl="6">

                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search">
                                        </b-form-input>

                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">
                                                Clear
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </b-col>

                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">

                                        <b-form-select v-model="perPage" :options="pageOptions">
                                        </b-form-select>

                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="table-responsive datatable-vue mt-3">

                                <b-table show-empty stacked="md" responsive :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <!-- Employee -->
                                    <template #cell(employee)="data">
                                        <div class="d-flex align-items-center">
                                            <img v-if="data.item.payroll_sheet_entry.employee.additional_info.photo" :src="host + data.item.payroll_sheet_entry.employee.additional_info.photo" class="rounded-circle me-2" width="40" height="40">

                                            <div>
                                                <strong>
                                                    {{ data.item.payroll_sheet_entry.employee.full_name }}
                                                </strong>

                                                <br>

                                                <small class="text-muted">
                                                    {{
                        data.item.payroll_sheet_entry.employee.additional_info.employee_id
                    }}
                                                </small>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Department -->
                                    <template #cell(department)="data">
                                        <div>
                                            {{ data.item.payroll_sheet_entry.department }}

                                            <br>

                                            <small class="text-muted">
                                                {{ data.item.payroll_sheet_entry.designation }}
                                            </small>
                                        </div>
                                    </template>

                                    <!-- Bank -->
                                    <template #cell(bank)="data">
                                        <div v-if="data.item.payroll_sheet_entry.bank_detail">
                                            {{ data.item.payroll_sheet_entry.bank_detail.bank_name }}

                                            <br>

                                            <small class="text-muted">
                                                Account No:  {{
                                                    data.item?.payroll_sheet_entry?.bank_detail?.account_number
                                                }}
                                            </small>
                                            <br>
                                            <small class="text-muted">
                                                Routing No:  {{
                                                    data.item?.payroll_sheet_entry?.bank_detail?.routing_number
                                                }}
                                            </small>
                                        </div>

                                        <span v-else>-</span>
                                    </template>

                                    <!-- Net Pay -->
                                    <template #cell(net_pay)="data">
                                        {{
            formatCurrency(
                data.item.payroll_sheet_entry.net_pay
            )
        }}
                                    </template>

                                    <!-- Pay Amount -->
                                    <template #cell(pay_amount)="data">
                                        {{ formatCurrency(data.item.pay_amount) }}
                                    </template>

                                    <!-- Status -->
                                    <template #cell(status)="data">
                                        <span class="badge" :class="{
                'bg-success': data.item.status === 'PAID',
                'bg-warning': data.item.status === 'PARTIAL',
                'bg-danger': data.item.status === 'UNPAID'
            }">
                                            {{ data.item.status }}
                                        </span>
                                    </template>

                                    <!-- Actions -->
                                    <template #cell(actions)="row">
                                        <b-button size="sm" variant="outline-primary" v-if="
                row.item.payroll_sheet_entry.payroll_slip?.slip_data?.payments?.length
            " @click="row.toggleDetails">
                                            <i class="fa" :class="
                    row.detailsShowing
                        ? 'fa-chevron-up'
                        : 'fa-chevron-down'
                "></i>

                                            {{
                row.detailsShowing
                    ? 'Hide'
                    : 'Payments'
            }}
                                        </b-button>
                                    </template>

                                    <!-- Row Details -->
                                    <template #row-details="row">

                                        <div class="p-2 bg-light rounded">

                                            <h6 class="mb-3">
                                                Previous Payments
                                            </h6>

                                            <b-table small bordered hover responsive :items="
                    row.item.payroll_sheet_entry
                        .payroll_slip
                        .slip_data
                        .payments
                " :fields="paymentFields" class="mb-0">

                                                <template #cell(amount)="data">
                                                    {{ formatCurrency(data.item.amount) }}
                                                </template>

                                                <template #cell(disbursed_on)="data">
                                                    {{ formatDate(data.item.disbursed_on) }}
                                                </template>

                                                <template #cell(authorized_by)="data">
                                                    {{ data.item.authorized_by }}
                                                </template>

                                            </b-table>

                                        </div>

                                    </template>

                                </b-table>

                                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="right" class="mt-3">
                                </b-pagination>

                                <b-button variant="success" class="mb-3" @click="downloadCSV">
                                    <i class="fa fa-download me-1"></i>
                                    Export CSV
                                </b-button>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from '../../../../_helpers/host';

export default {
    data() {
        return {
            host: myHost.host,
            filter: '',
            perPage: 25,
            currentPage: 1,
            pageOptions: [25, 50, 100],

            tablefields: [{
                    key: 'employee',
                    label: 'Employee'
                },
                {
                    key: 'department',
                    label: 'Department'
                },
                {
                    key: 'bank',
                    label: 'Bank'
                },
                {
                    key: 'net_pay',
                    label: 'Net Pay'
                },
                {
                    key: 'pay_amount',
                    label: 'Paid Amount'
                },
                {
                    key: 'status',
                    label: 'Status'
                },
                {
                    key: 'actions',
                    label: 'Payments'
                }
            ],
            paymentFields: [{
                    key: 'amount',
                    label: 'Paid Amount'
                },
                {
                    key: 'disbursed_on',
                    label: 'Disbursed On'
                },
                {
                    key: 'authorized_by',
                    label: 'Authorized By'
                }
            ]
        };
    },

    computed: {
        ...mapState({
            details: state => state.payroll.disbursement_detail,
            loading: state => state.payroll.submitLoading,
            error: state => state.payroll.submitError,

        }),
        items() {
            return this.details ?.entries || [];
        }

    },
    created() {

    },
    mounted() {
        this.$store.dispatch("payroll/fetchDisbursementDetail", this.$route.params.id)
    },

    watch: {
        details(oldValue, newValue) {

        },

    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        formatCurrency(amount) {
            return new Intl.NumberFormat('en-BD', {
                style: 'currency',
                currency: 'BDT',
                minimumFractionDigits: 0
            }).format(amount || 0);
        },
        formatDate(date) {
            if (!date) return '-'

            return new Date(date).toLocaleString('en-BD', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        formatPayrollMonth(month, year) {
            if (!month || !year) return '-'

            const date = new Date(year, month - 1)

            return date.toLocaleString('en-US', {
                month: 'long',
                year: 'numeric'
            })
        },
        downloadCSV() {
            const rows = this.items.map(item => {
                const employee =
                    item.payroll_sheet_entry.employee.full_name

                const employeeId =
                    item.payroll_sheet_entry.employee
                    .additional_info.employee_id

                const department =
                    item.payroll_sheet_entry.department

                const designation =
                    item.payroll_sheet_entry.designation

                const bank =
                    item.payroll_sheet_entry.bank_detail ?.bank_name || ''

                const account =
                    item.payroll_sheet_entry.bank_detail ?.account_number || ''
                
                const routing =
                    item.payroll_sheet_entry.bank_detail ?.routing_number || ''


                const payments =
                    item.payroll_sheet_entry.payroll_slip?.slip_data ?.payments || []

                return {
                    Employee: employee,
                    Employee_ID: employeeId,
                    Department: department,
                    Designation: designation,
                    Bank: bank,
                    Account_Number: account,
                    Routing_Number: routing,
                    Net_Pay: item.payroll_sheet_entry.net_pay,
                    Paid_Amount: item.pay_amount,
                    Status: item.status,

                    // Previous_Payments: payments
                    //     .map(
                    //         p =>
                    //         `${p.amount} (${p.authorized_by} - ${this.formatDate(
                    //             p.disbursed_on
                    //         )})`
                    //     )
                    //     .join(' | ')
                }
            })

            const csv = this.convertToCSV(rows)

            const blob = new Blob([csv], {
                type: 'text/csv;charset=utf-8;'
            })

            const link = document.createElement('a')

            const url = URL.createObjectURL(blob)

            link.href = url

            link.setAttribute(
                'download',
                `disbursement-${this.details.id}.csv`
            )

            document.body.appendChild(link)

            link.click()

            document.body.removeChild(link)
        },

        convertToCSV(data) {
            if (!data.length) return ''

            const headers = Object.keys(data[0])

            const csvRows = [
                headers.join(',')
            ]

            data.forEach(row => {
                const values = headers.map(header => {
                    const value = row[header] ?? ''

                    return `"${String(value).replace(/"/g, '""')}"`
                })

                csvRows.push(values.join(','))
            })

            return csvRows.join('\n')
        }
    }
}
</script>

<style scoped>
.info-label {
    font-size: 13px;
    color: #6c757d;
    font-weight: 600;
    margin-bottom: 2px;
}

.info-value {
    font-size: 15px;
    font-weight: 500;
    color: #2b2b2b;
}

.profile-img {
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #f8f9fa;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
}

.custom-card {
    border: 0;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .06);
    overflow: hidden;
}

.custom-card .card-header {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    font-weight: 600;
    padding: 12px 24px;
}

.status-badge {
    font-size: 12px;
    padding: 6px 10px;
}

.page-section {
    margin-bottom: 20px;
}

.creator-card {
    position: sticky;
    top: 20px;
}
</style>
